<template>
	<V2RequestCreate
		v-if="isEditMode"
		v-bind="$attrs"
		:id="requestId"
		resource="request"
	/>
	<V2Layout v-else><div class="v2-page-wrap">
		<V2Review
			:id="requestId"
			:resource="$attrs.resource || 'request'"
			:key="$route.fullPath"
		/>
	</div></V2Layout>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import V2Layout from '@/layouts/V2Layout';
import V2RequestCreate from '@/pages-v2/requests/create.vue';
import V2Review from '@/pages-v2/requests/review/index.vue';

export default {
	name: 'V2RequestDetails',

	components: {
		V2Layout,
		V2RequestCreate,
		V2Review,
	},

	computed: {
		...mapState('app', {
			appSide: 'side',
		}),

		requestId() {
			return ~~this.$route.params.id;
		},

		isEditMode() {
			return this.appSide === 'dsp' && this.$attrs.resource === 'request';
		},
	},
};
</script>

<style lang="sass" scoped>
@import '~@/assets/styles/v2-page-overrides'
</style>
